var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIconSnackbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#DB4437"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3675 32.5001H36.1915V35.4901H30.3675V32.5001ZM30.3675 20.5401H40.5595V23.5301H30.3675V20.5401ZM30.3675 26.5201H39.1035V29.5101H30.3675V26.5201ZM12.8955 35.4901C12.8955 37.1346 14.2059 38.4801 15.8075 38.4801H24.5435C26.1451 38.4801 27.4555 37.1346 27.4555 35.4901V20.5401H12.8955V35.4901ZM28.9115 16.0551H24.5435L23.0875 14.5601H17.2635L15.8075 16.0551H11.4395V19.0451H28.9115V16.0551Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconSnackbar);
export default __webpack_public_path__ + "static/media/DeleteIconSnackbar.d4bd44b92bbf893591e6fd23cfc4670a.svg";
export { ForwardRef as ReactComponent };